import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import i18next from "i18next";

import { useFreeProxyData } from "../store/freeProxy/freeProxy.selectors";

import { toBooleanFromString } from "../utils/helpers";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useGetProxies = () => {
  const {
    getProxies,
    getProxyPagination,
    getFreeProxiesForExport,
    toFirstRenderFalse,
    getCountryInfo,
  } = useDispatchedActions();
  const { isOpenDropDown, isProxyLoaded, isFirstRender } = useFreeProxyData();

  const [searchParams] = useSearchParams();
  const lang = i18next.language;

  const englishCountryName = searchParams.get("country")
    ? decodeURIComponent(searchParams.get("country"))
    : "";

  const cityName = searchParams.get("city")
    ? decodeURIComponent(searchParams.get("city"))
    : "";

  const proxyType = searchParams.get("type") || "";
  const google = toBooleanFromString(searchParams.get("google")) ?? "";

  const page = Number(searchParams.get("page") || "1") - 1;
  const size = 10;

  const params = {
    englishCountryName,
    cityName,
    proxyType,
    google,
    page,
    size,
  };

  const exportParams = {
    page: 0,
    size: 0,
    englishCountryName,
    cityName,
    proxyType,
    google,
  };

  useEffect(() => {
    if (!englishCountryName) return;

    getCountryInfo({ countryTag: englishCountryName, languageCode: lang });
  }, [englishCountryName, lang]);

  useEffect(() => {
    if (!isProxyLoaded) {
      getProxies(params);
      getProxyPagination(params);
    }
  }, [isProxyLoaded]);

  useEffect(() => {
    getFreeProxiesForExport(exportParams);
  }, [englishCountryName, cityName, proxyType, google]);

  useEffect(() => {
    if (isFirstRender) {
      toFirstRenderFalse();
    } else if (!isOpenDropDown) {
      getProxies(params);
      getProxyPagination(params);
    }
  }, [
    englishCountryName,
    cityName,
    proxyType,
    google,
    page,
    size,
    isOpenDropDown,
  ]);
};
